module.exports = __webpack_public_path__ + "img/dribble.57589c02.svg";